import { isUncertainSend, retryAfterSeconds, routingErrorCode, routingErrorPolicy } from '../../features/switchover/models/routingErrors';

export const isUncertainMessage = item => !['submitted', 'sent', 'delivered', 'read'].includes(item?.status)
  && isUncertainSend(item?.failure?.code);

export function createSendFailure(error, now = Date.now()) {
  const code = routingErrorCode(error);
  const details = error?.details || error?.response?.data?.error?.details || {};
  const seconds = retryAfterSeconds(details);
  const policy = routingErrorPolicy(code, details);
  const retry = error.retryAction || policy?.retry;
  const delayed = (isUncertainSend(code) || code === 'MESSAGING_OWNERSHIP_SEND_IN_FLIGHT')
    && (seconds !== null || isUncertainSend(code));
  return {
    message: policy?.message || error.message || 'Message could not be sent.',
    ...(code ? { code } : {}),
    ...(retry ? { retry_action: retry } : {}),
    ...(typeof details.operation_id === 'string' ? { operation_id: details.operation_id } : {}),
    ...(delayed ? { retry_after_seconds: seconds ?? 120, retry_at: now + (seconds ?? 120) * 1000 } : {}),
  };
}

export const sendRetrySeconds = (failure, now = Date.now()) => Number.isFinite(failure?.retry_at)
  ? Math.max(0, Math.ceil((failure.retry_at - now) / 1000)) : 0;
